<div class="card">
  <div class="card-body">
    <a (click)="toggleOpen()">
      <div class="card-title mb-0 p-2 d-flex justify-content-between align-items-center flagTitle">
        <div class="d-flex align-items-center gap-2" style="font-weight: 600">
          @if (titleIcon(); as titleIcon) {
            <chitin-icon class="titleIcon" [color]="titleIconColor()" [icon]="titleIcon" />
          }
          <span>{{ title ?? '' }}</span>
        </div>
        <div class="d-flex align-items-center gap-3">
          @if (titleEnd(); as titleEnd) {
            <div>{{ titleEnd }}</div>
            <div class="verticalSeparator"></div>
          }
          <chitin-icon [icon]="isOpen ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'" />
        </div>
      </div>
    </a>
    @if (isOpen) {
      <div class="contentWrapper">
        <ng-content />
      </div>
    }
  </div>
</div>
